import {Box, Stack, styled} from '@mui/material';

const StyledFooterContainer = styled(Box)`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

const StyledStack = styled(Stack)`
	padding-top: 16px;
	border-top: 1px solid ${({theme}) => theme.palette.other.divider};
	gap: 16px;
`;

export {StyledFooterContainer, StyledStack};
